// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 53 ? "webfontloader" : chunkId) + "." + {"53":"e980c90c","677":"7e2c1266"}[chunkId] + ".js";
};